import { useEffect } from "react";
import { getRootDispatcher } from "@/analytics";
import { useSessionId } from "@/sdk";
import { usePartner } from "@/sdk/agent/hooks/usePartner";
import { getProductOffer } from "../api/getProductOffer";
import { useProductOfferStore } from "../stores";
import { updatePrimaryProductSaleProgress } from "../utils/updatePrimaryProductSaleProgress";

export const useQuerySelectedProductOffer = () => {
    const partner = usePartner();
    const sessionId = useSessionId();
    const selectedProduct = useProductOfferStore((state) => state.getSelectedProduct(sessionId));

    useEffect(() => {
        if (selectedProduct == null) {
            return; // no active product
        }

        void (async () => {
            try {
                const { enrollmentStatus } = await getProductOffer(
                    selectedProduct.id,
                    partner,
                    selectedProduct.salesProvider,
                );

                if (enrollmentStatus == null) {
                    return;
                }

                updatePrimaryProductSaleProgress({
                    offerId: selectedProduct.id,
                    status: enrollmentStatus,
                    salesProvider: selectedProduct.salesProvider,
                });
            } catch (error) {
                void getRootDispatcher().dispatchBusinessEvent("GetProductOfferError", {
                    productOfferId: selectedProduct.id,
                    partner,
                    error,
                });
            }
        })();
    }, [partner, selectedProduct]);
};
